import React, {Fragment} from 'react';
import { AxlInput, AxlPanel, AxlButton, AxlTextArea } from 'axl-reactjs-ui';
import {inject, observer} from "mobx-react";
import moment from "moment";

import styles, * as E from './styles';

@inject('shipmentStore')
@observer
class ShipmentClone extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      clonedShipment: null,
    }
  }

  onUpdate = (name) => (e) => {
    if (e.target.value !== undefined) {
      this.setState({[name]: e.target.value});
    }
  }

  viewShipment = () => {
    const {clonedShipment} = this.state;
    const {onClose} = this.props;

    if (!clonedShipment) return;
    onClose();
    window.open(`/deliveries/${moment(clonedShipment.dropoff_earliest_ts).format("YYYY-MM-DD")}/all/${clonedShipment.id}`);
  }

  clone = () => {
    const {shipmentStore, shipment, onClose} = this.props;
    if (!shipment) return;

    this.setState({error: ''});
    shipmentStore.cloneShipment(shipment.id, (res) => {
      if (res.ok) {
        this.setState({clonedShipment: res.data})
      } else {
        this.setState({error: res.data.message});
      }
    })
  }

  render() {
    const {error, clonedShipment} = this.state;
    const {shipment, shipmentStore} = this.props;
    const {cloning} = shipmentStore;

    return <E.Container style={styles.Container}>
      <div style={styles.HeaderTitle}>Clone Shipment</div>
      <AxlPanel>
        <AxlPanel.Row>
          <AxlPanel.Col style={styles.GroupPanel}>
            <div style={styles.GroupField}>
              {!clonedShipment && (
                <div style={styles.Field}>
                  Are you sure to clone shipment for
                  <div style={{padding: '5px 0'}}><strong>{shipment.customer.name}</strong></div>
                  <div><strong>{shipment.internal_id}</strong></div>
                </div>
              )}
              {clonedShipment && (
                <div style={styles.Field}>
                  {clonedShipment.source === 'cloned' && (
                    <div>
                      <div>Shipment already cloned before</div>
                      <div>Other shipment ID is <strong>{clonedShipment.id}</strong></div>
                      <div style={styles.Error}>Shipment with internal ID {clonedShipment.internal_id} has 2 records. If you want more, please contact our tech team.</div>
                    </div>
                  )}
                  {clonedShipment.source !== 'cloned' && (
                    <div>
                      <div>Shipment has been cloned</div>
                      <div>New shipment ID <strong>{clonedShipment.id}</strong></div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </AxlPanel.Col>
        </AxlPanel.Row>
        <AxlPanel.Row>
          <AxlPanel.Col>
            <AxlPanel.Row align={`center`}>
              {!clonedShipment && (
                <Fragment>
                  <div style={{...styles.Field, ...styles.FieldButton}}>
                    <AxlButton compact bg={`gray`} onClick={this.props.onClose} style={styles.buttonControl}>
                      {`Cancel`}
                    </AxlButton>
                  </div>
                  <div style={{...styles.Field, ...styles.FieldButton}}>
                    <AxlButton compact bg={`pink`} loading={cloning} disabled={cloning} onClick={this.clone} style={styles.buttonControl}>
                      {`Clone`}
                    </AxlButton>
                  </div>
                </Fragment>
              )}
              {clonedShipment && (
                <AxlButton compact bg={`bluish`} style={styles.buttonControl} onClick={this.viewShipment}>
                  {`View Shipment`}
                </AxlButton>
              )}
            </AxlPanel.Row>
          </AxlPanel.Col>
        </AxlPanel.Row>
        {error && <div style={styles.Error}>{error}</div>}
      </AxlPanel>
    </E.Container>
  }
}

export default ShipmentClone;